export interface CommunicationIcon {
    value: number;
    text: string;
    iconClass: string;
}

const commIcons: CommunicationIcon[] = [
    { value: 0, text: "Select an Icon", iconClass: "" },
    { value: 1, text: "Webinar/Instructions", iconClass: "fa-solid fa-person-chalkboard" },
    { value: 2, text: "Deadline", iconClass: "fa-solid fa-user-clock" },
    { value: 3, text: "Pie Chart/Investments/Contributions", iconClass: "fa-solid fa-chart-pie" },
    { value: 4, text: "Receipt", iconClass: "fa-solid fa-receipt" },
    { value: 5, text: "Credit Card/New Card", iconClass: "fa-solid fa-credit-card" },
    { value: 6, text: "Medical Claim/Invoice", iconClass: "fa-solid fa-file-invoice-dollar" },
    { value: 7, text: "Contributions/Savings", iconClass: "fa-solid fa-sack-dollar" },
    { value: 8, text: "Medical Related/Insurance Link", iconClass: "fa-solid fa-briefcase-medical" },
    { value: 9, text: "Pharmacy Related/OTC Meds", iconClass: "fa-solid fa-capsules" },
    { value: 10, text: "Beneficiary/Dependents", iconClass: "fa-solid fa-people-group" },
    { value: 11, text: "Legal/Regulatory Updates", iconClass: "fa-solid fa-scale-balanced" },
    { value: 12, text: "Alert/Notification", iconClass: "fa-solid fa-bell" },
    { value: 13, text: "Reminder/Specific Date or Deadline", iconClass: "fa-solid fa-calendar-check" },
    { value: 14, text: "To Do List/Tasks to Complete", iconClass: "fa-solid fa-clipboard-list" },
    { value: 15, text: "Deadline/Time Sensitive Update", iconClass: "fa-solid fa-clock" },
    { value: 16, text: "Dependent Care Plan", iconClass: "fa-solid fa-hand-holding-heart" },
    { value: 17, text: "Commuter Parking Plan", iconClass: "fa-solid fa-car" },
    { value: 18, text: "Commuter Transit Plan", iconClass: "fa-solid fa-train-subway" }
];

export const CommunicationIcons = commIcons;